<template>
  <div>
      <el-form class="login-container" label-position="left"
               label-width="0px">
        <h3 class="login_title">数据上报demo</h3>
        <el-form-item>
          <el-input type="text" v-model="input"
                    auto-complete="off" placeholder="adid"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input type="text" v-model="input1"
                    auto-complete="off" placeholder="requestid"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="values" placeholder="上报类型">
            <el-option
              v-for="items in level"
              :key="items.value"
              :label="items.label"
              :value="items.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-button type="success" v-on:click="update">
          用户上报
        </el-button>
      </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      input: '',
      input1:'',
      values:'',
      level: [{
        value: 'SUBMIT',
        label: '表单提交'
      },
        {
          value: 'WEBPAY',
          label: '网页购买'
        },{
        value: 'REACTIVATION',
        label: '自定义拉活'
      }, {
        value: 'ACTIVATION',
        label: '自定义激活'
      },
        {
          value: 'PAY',
          label: '自定义付费'
        },
        {
          value: 'RETENTION_1',
          label: '自定义次留'
        },
        {
          value: 'ADD_SCREEN',
          label: '加桌'
        }],
    }
  },
  methods: {
    update() {
      console.log(this.input)
      console.log(this.input1)
      let pams={
        token:'050882462da615ea58cd1338327c01ab9c572e42e6b97c3df14f9a335547de5f',
        adid:'96f898521c3c57659e00'
      }
      console.log(this.values)
     this.PostMoeny(pams)
    },
    //用户上报
    async PostMoeny(pams){
      console.log(pams)
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
        await this.$axios.post('api/openapi/v1/advertiser/behavior/upload?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
          {
          "srcId":"ds-202308150901",
          "pageUrl":"https://www.baidu.com",
          "srcType":"Web",
          "dataList":{
            "cvTime":time,
            "requestId":this.input1,
            "cvType":this.values,
            "creativeId":this.input
          }
        }).then(resp=>{
        if (resp.data.code!==0){
          this.$notify.error({
            title: '错误',
            message: '上传失败'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '上传成功',
            type: 'success'
          });
        }
        }
      )
    },
  }
  }
</script>
<style>
.login-container {
  border-radius: 15px;
  background-clip: padding-box;
  margin: 90px auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}
#poster {
  background-position: center;
  height: 100%;
  width: 100%;
  background-size: cover;
  position: fixed;
}
body{
  margin: 0px;
}
.login_title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}

</style>
<style scoped="scoped">
.btn-upload {
  z-index: 100;
  border-radius: 30px;
  box-shadow: 0 2px 12px 0 rgba(91, 156, 255, 0.9)
}
.el-upload {
  margin: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/update.vue